import emitter from "tiny-emitter/instance"
import {isFunction} from "lodash"

const EVENT = "PB_MFA_REQUIRED"

export type Complete = () => void
export type Cancel = () => void

class MFA {
  private _show = false
  private _complete?: Complete
  private _cancel?: Cancel

  set show(value: boolean) {
    const emit = this._show !== value
    this._show = value
    if (emit) emitter.emit(EVENT)
  }

  get show() {
    return this._show
  }

  start(complete: Complete, cancel: Cancel) {
    this.show = true
    this._complete = complete
    this._cancel = cancel
  }

  complete() {
    this.show = false
    if (isFunction(this._complete)) {
      this._complete()
    }
  }

  cancel() {
    this.show = false
    if (isFunction(this._cancel)) {
      this._cancel()
    }
  }

  addEventListener(cb: () => void) {
    emitter.on(EVENT, cb)
  }

  removeEventListener(cb: () => void) {
    emitter.off(EVENT, cb)
  }
}

export default new MFA()
